var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSocialCultural(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1103",
    "data-name": "Rectangle 1103",
    width: 33.705,
    height: 33.712,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_social_cultural",
    transform: "translate(-328.833 -215.421)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(328.833 215.421)",
    fill: "rgba(195,230,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216",
    transform: "translate(336.981 223.565)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_216-2",
    "data-name": "Group 216",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21882",
    "data-name": "Path 21882",
    d: "M33.7,16.863A16.841,16.841,0,0,0,5.413,4.492L2.13,1.206l-.942.942L4.475,5.434a16.839,16.839,0,0,0,23.8,23.8l3.286,3.286.942-.942-3.286-3.286A16.723,16.723,0,0,0,33.7,16.863m-3.789,7.5a13.87,13.87,0,0,0-1.334-5.456,15.451,15.451,0,0,1,3.279-.717,14.88,14.88,0,0,1-1.945,6.173m2.012-7.5c0,.146-.018.289-.021.435a16.371,16.371,0,0,0-3.7.8,27.872,27.872,0,0,0-4.871-6.79L27.957,6.69a14.966,14.966,0,0,1,3.971,10.173m-16.028,0-4.92,4.92a27.658,27.658,0,0,1-4.7-6.476,16.351,16.351,0,0,0,4.931-3.133Zm-3.743-5.631A16.382,16.382,0,0,0,15.286,6.3a27.6,27.6,0,0,1,6.48,4.7l-4.924,4.924Zm4.685,6.573,4.689,4.689a16.374,16.374,0,0,0-3.126,4.92,27.19,27.19,0,0,1-6.483-4.685Zm.942-.942,4.924-4.924a27.658,27.658,0,0,1,4.7,6.476,16.25,16.25,0,0,0-4.931,3.136ZM16.417,1.8c.143,0,.282-.021.425-.021A14.966,14.966,0,0,1,27.015,5.748l-4.621,4.621A27.955,27.955,0,0,0,15.6,5.5a16.677,16.677,0,0,0,.817-3.7m-.9.043a15.422,15.422,0,0,1-.728,3.279A13.906,13.906,0,0,0,9.334,3.789a14.933,14.933,0,0,1,6.18-1.948M7.768,4.831c1.791-.478,4.16-.068,6.715,1.088A15.517,15.517,0,0,1,11.525,10.6L6.673,5.748c.353-.325.717-.632,1.1-.917M4.814,7.793a13.9,13.9,0,0,1,.917-1.1l4.853,4.856A15.5,15.5,0,0,1,5.9,14.5C4.746,11.95,4.336,9.58,4.814,7.793M3.772,9.366a13.9,13.9,0,0,0,1.334,5.449,15.636,15.636,0,0,1-3.276.714A15.066,15.066,0,0,1,3.772,9.366M1.788,16.428a16.554,16.554,0,0,0,3.693-.806,27.872,27.872,0,0,0,4.871,6.79L5.731,27.032a15.008,15.008,0,0,1-3.943-10.6M17.27,31.917a15.028,15.028,0,0,1-10.6-3.943l4.621-4.617a28.119,28.119,0,0,0,6.787,4.892,16.589,16.589,0,0,0-.81,3.668m.9-.043a15.421,15.421,0,0,1,.721-3.251c.589.26,1.174.5,1.752.692a12.221,12.221,0,0,0,3.632.653,15.05,15.05,0,0,1-6.105,1.905m7.743-2.983a9.041,9.041,0,0,1-4.992-.421,18.188,18.188,0,0,1-1.716-.678,15.454,15.454,0,0,1,2.951-4.671l4.856,4.853c-.357.325-.721.632-1.1.917m2.958-2.954c-.285.378-.592.742-.917,1.1L23.1,22.18a15.431,15.431,0,0,1,4.681-2.958c1.156,2.555,1.566,4.924,1.088,6.715",
    transform: "translate(0 -0.002)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21883",
    "data-name": "Path 21883",
    d: "M9.344,11.274A13.948,13.948,0,0,0,8.01,5.815,15.4,15.4,0,0,1,11.289,5.1a14.912,14.912,0,0,1-1.945,6.176",
    transform: "translate(20.571 13.091)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21884",
    "data-name": "Path 21884",
    d: "M15.132,12.047c0,.146-.018.289-.021.435a16.226,16.226,0,0,0-3.7.806A27.792,27.792,0,0,0,6.54,6.495l4.621-4.621a14.956,14.956,0,0,1,3.971,10.173",
    transform: "translate(16.796 4.811)",
    fill: "#54a847"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21885",
    "data-name": "Path 21885",
    d: "M11.38,8.1,6.456,13.024a27.477,27.477,0,0,1-4.7-6.48A16.4,16.4,0,0,0,6.691,3.411Z",
    transform: "translate(4.52 8.758)",
    fill: "#4cc0cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21886",
    "data-name": "Path 21886",
    d: "M3.407,6.7A16.446,16.446,0,0,0,6.54,1.765a27.623,27.623,0,0,1,6.48,4.7L8.1,11.385Z",
    transform: "translate(8.75 4.531)",
    fill: "#54a847"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21887",
    "data-name": "Path 21887",
    d: "M8.264,4.989l4.689,4.689A16.4,16.4,0,0,0,9.823,14.6,27.452,27.452,0,0,1,3.34,9.913Z",
    transform: "translate(8.578 12.811)",
    fill: "#4cc0cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21888",
    "data-name": "Path 21888",
    d: "M4.984,8.269,9.908,3.345a27.7,27.7,0,0,1,4.7,6.48,16.368,16.368,0,0,0-4.935,3.133Z",
    transform: "translate(12.8 8.589)",
    fill: "#54a847"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21889",
    "data-name": "Path 21889",
    d: "M5.189.519C5.332.516,5.471.5,5.614.5h0A14.964,14.964,0,0,1,15.786,4.469L11.166,9.09A27.82,27.82,0,0,0,4.372,4.22a16.479,16.479,0,0,0,.817-3.7",
    transform: "translate(11.228 1.277)",
    fill: "#54a847"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21890",
    "data-name": "Path 21890",
    d: "M8.8.516A15.308,15.308,0,0,1,8.065,3.8,13.891,13.891,0,0,0,2.616,2.464,14.864,14.864,0,0,1,8.8.516",
    transform: "translate(6.718 1.323)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21891",
    "data-name": "Path 21891",
    d: "M2.965,1.495c1.791-.478,4.16-.068,6.715,1.088A15.515,15.515,0,0,1,6.726,7.265L1.87,2.412c.353-.325.717-.632,1.1-.917",
    transform: "translate(4.802 3.335)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21892",
    "data-name": "Path 21892",
    d: "M1.49,2.977c.282-.378.589-.746.913-1.1L7.264,6.73A15.464,15.464,0,0,1,2.575,9.688C1.419,7.133,1.012,4.768,1.49,2.977",
    transform: "translate(3.323 4.811)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21893",
    "data-name": "Path 21893",
    d: "M2.454,2.625A13.88,13.88,0,0,0,3.792,8.07a15.452,15.452,0,0,1-3.279.717A15.066,15.066,0,0,1,2.454,2.625",
    transform: "translate(1.317 6.74)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21894",
    "data-name": "Path 21894",
    d: "M.506,5.183A16.358,16.358,0,0,0,4.2,4.377a27.887,27.887,0,0,0,4.871,6.794L4.448,15.791A15.038,15.038,0,0,1,.506,5.183",
    transform: "translate(1.282 11.239)",
    fill: "#4cc0cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21895",
    "data-name": "Path 21895",
    d: "M12.467,15.109a15.017,15.017,0,0,1-10.6-3.943L6.487,6.545a28.011,28.011,0,0,0,6.79,4.892,16.464,16.464,0,0,0-.81,3.672",
    transform: "translate(4.802 16.807)",
    fill: "#4cc0cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21896",
    "data-name": "Path 21896",
    d: "M5.093,11.273a15.42,15.42,0,0,1,.721-3.251c.589.26,1.177.5,1.756.692a12.2,12.2,0,0,0,3.632.653,15.065,15.065,0,0,1-6.109,1.905",
    transform: "translate(13.08 20.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21897",
    "data-name": "Path 21897",
    d: "M12.091,12.25A9.041,9.041,0,0,1,7.1,11.829a18.188,18.188,0,0,1-1.716-.678A15.454,15.454,0,0,1,8.334,6.48l4.856,4.853c-.357.325-.721.632-1.1.917",
    transform: "translate(13.824 16.64)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21898",
    "data-name": "Path 21898",
    d: "M12.245,12.1c-.285.378-.592.742-.917,1.1L6.475,8.345a15.431,15.431,0,0,1,4.681-2.958c1.156,2.555,1.566,4.924,1.088,6.715",
    transform: "translate(16.629 13.833)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21899",
    "data-name": "Path 21899",
    d: "M8.7,5.428l-.439-.439L3.341,9.913A27.11,27.11,0,0,0,9.824,14.6c.054-.132.121-.257.178-.389a27.561,27.561,0,0,1-5.788-4.3Z",
    transform: "translate(8.58 12.811)",
    fill: "#5ff0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21900",
    "data-name": "Path 21900",
    d: "M10.319,3.806c-.139-.153-.268-.31-.414-.46L4.985,8.27l4.689,4.685c.15-.139.314-.264.471-.4L5.859,8.27Z",
    transform: "translate(12.802 8.591)",
    fill: "#6ddb5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21901",
    "data-name": "Path 21901",
    d: "M11.411,13.286c.246-.086.5-.161.746-.232A27.792,27.792,0,0,0,7.414,6.5L11.56,2.35c-.132-.157-.257-.321-.4-.475L6.54,6.5a27.8,27.8,0,0,1,4.871,6.79",
    transform: "translate(16.796 4.814)",
    fill: "#6ddb5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21902",
    "data-name": "Path 21902",
    d: "M6.539,1.765A16.446,16.446,0,0,1,3.406,6.7l4.689,4.689.439-.435L4.28,6.7A16.372,16.372,0,0,0,7.235,2.154c-.232-.128-.467-.271-.7-.389",
    transform: "translate(8.747 4.531)",
    fill: "#6ddb5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21903",
    "data-name": "Path 21903",
    d: "M2.634,6.545A16.452,16.452,0,0,0,7.091,3.812l-.4-.4A16.351,16.351,0,0,1,1.76,6.545a27.658,27.658,0,0,0,4.7,6.476l.46-.46A27.361,27.361,0,0,1,2.634,6.545",
    transform: "translate(4.52 8.761)",
    fill: "#5ff0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21904",
    "data-name": "Path 21904",
    d: "M11.166,9.09l.414-.414A27.614,27.614,0,0,0,5.246,4.22a16.479,16.479,0,0,0,.817-3.7c-.15,0-.3-.021-.45-.021s-.282.018-.425.021a16.479,16.479,0,0,1-.817,3.7A27.955,27.955,0,0,1,11.166,9.09",
    transform: "translate(11.228 1.277)",
    fill: "#6ddb5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21905",
    "data-name": "Path 21905",
    d: "M1.38,5.183a17.009,17.009,0,0,0,2.947-.571c-.039-.078-.089-.157-.128-.235a16.316,16.316,0,0,1-3.693.806A15.054,15.054,0,0,0,4.448,15.791l.478-.478A15.032,15.032,0,0,1,1.38,5.183",
    transform: "translate(1.282 11.239)",
    fill: "#5ff0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21906",
    "data-name": "Path 21906",
    d: "M2.744,11.166l4.2-4.2c-.153-.139-.3-.275-.453-.421L1.87,11.166a15.028,15.028,0,0,0,10.6,3.943l0-.018a14.971,14.971,0,0,1-9.727-3.925",
    transform: "translate(4.802 16.807)",
    fill: "#5ff0ff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSocialCultural);
export default __webpack_public_path__ + "static/media/ic_social_cultural.adf671ea40fee7fb2f13384a41a4ee6f.svg";
export { ForwardRef as ReactComponent };